// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:35:51

export default {
  "id": "the-hardest-puzzle-ever",
  "slug": "the-hardest-puzzle-ever",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9187c77336cf4622bc76f057efa5bbc7-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9187c77336cf4622bc76f057efa5bbc7/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "The Hardest Puzzle Ever",
      "description": "An Exciting Puzzle Game for the Whole Family! ?\n\nPlay together and train your brain every day! ?? Enjoy thrilling puzzles suitable even for the youngest players. With new levels added daily, there's always a fresh challenge waiting for you!\n\nHave fun, improve your skills, and become a true puzzle master! ??",
      "instructions": "In this game, your goal is to assemble a bright picture by moving pieces across the board. Simply drag and drop the pieces into the correct spots until the image is complete. Be careful, as some pieces may look similar, but only one spot is right for each. Once all the pieces are in place, you’ll see the beautiful picture come together! Enjoy the process and sharpen your attention!",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "logic",
        "sliding-puzzle",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "史上最难的谜题",
      "description": "全家适用的激动人心解谜游戏！？\n\n一起玩耍，每天锻炼你的大脑！？享受适合最年轻玩家的刺激谜题。每日新增关卡，总有新鲜挑战等你来挑战！\n\n享受乐趣，提高技能，成为真正的谜题大师！？",
      "instructions": "在这个游戏中，你的目标是通过在棋盘上移动拼图来拼凑出一个明亮的画面。只需将拼图拖放到正确的位置，直到画面完整为止。小心，因为有些拼图看起来很相似，但每个位置只能放一个。当所有拼图都放好后，你将看到美丽的画面拼凑出来！享受这个过程，并锻炼你的注意力！",
      "genres": [
        "拼图"
      ],
      "tags": [
        "逻辑游戏",
        "滑动拼图",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "史上最難的謎題",
      "description": "一個適合全家一起玩的刺激謎題遊戲！？\n\n一起玩，每天鍛鍊你的大腦！？享受適合最年幼玩家們的刺激謎題。每天都有新關卡加入，總有新的挑戰等待著你！\n\n歡樂遊戲，提升技能，成為真正的謎題大師！？",
      "instructions": "在這款遊戲中，你的目標是透過在棋盤上移動棋子，拼湊出亮麗的圖片。只需簡單地將棋子拖放到正確的位置，直到圖片完成為止。請小心，因為有些棋子看起來可能很相似，但每個位置只有一個是正確的。當所有棋子就位後，你將會看到美麗的圖片逐漸成形！享受這個過程並鍛鍊你的注意力！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "邏輯",
        "滑動拼圖",
        "消磨時間小遊戲"
      ]
    },
    "zh-HK": {
      "title": "史上最難的謎題",
      "description": "全家共享的刺激益智遊戲！？\n\n一起遊戲，每天鍛煉你的腦力！？享受適合年輕玩家的刺激謎題。每日新增新關卡，總有新挑戰等待著你！\n\n開心遊戲，提升技能，成為真正的謎題大師！？",
      "instructions": "在這款遊戲中，你的目標是透過在棋盤上移動拼圖塊，組合成一個亮麗的圖片。只需簡單地將拼圖塊拖放到正確的位置，直到圖片完成為止。請小心，因為有些拼圖塊可能看起來很相似，但每個位置只適合一塊。一旦所有拼圖塊都放對位置，你將會看到美麗的圖片逐漸成形！享受這個過程並鍛鍊你的注意力！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "邏輯",
        "滑動拼圖",
        "時間消磨者"
      ]
    },
    "ja": {
      "title": "史上最難しいパズル",
      "description": "家族全員で楽しめる興味深いパズルゲーム！？\n\n一緒に遊び、毎日脳を鍛えましょう！？最も若いプレイヤーにも適した刺激的なパズルを楽しみましょう。毎日新しいレベルが追加され、常に新たな挑戦があなたを待っています！\n\n楽しみながらスキルを向上させ、本物のパズルマスターに！？",
      "instructions": "このゲームでは、ボード上でピースを動かして明るい絵を組み立てるのが目標です。ピースを正しい場所にドラッグ＆ドロップして、画像が完成するまで続けます。注意してください、いくつかのピースは似ているように見えるかもしれませんが、各ピースには正しい場所が一つだけあります。すべてのピースが配置されたら、美しい絵が完成するのが見られます！このプロセスを楽しみながら、集中力を鍛えましょう！",
      "genres": [
        "パズル"
      ],
      "tags": [
        "ロジック",
        "スライディングパズル",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "최难的 퍼즐이었습니다",
      "description": "가족 모두를 위한 흥미진진한 패uzzle 게임! ?\n\n함께 즐기고 매일 뇌를 훈련하세요! ?? 최소 연령자부터도 즐길 수 있는 흥미로운 패uzzle을 즐겨보세요. 매일 새로운 레벨이 추가되어 있어 언제나 새로운 도전이 기다리고 있습니다!\n\n楽しみながら 기술을 향상시키고 진정한 패uzzle 마스터가 되세요! ??",
      "instructions": "이 게임에서는 보드 위에서 조각을 이동하여 밝은 이미지를 조립하는 것이 목표입니다. 단순히 조각을 드래그하고 드롭하여 이미지가 완성될 때까지 올바른 공간에 놓으세요. 주의하세요, 일부 조각들은 비슷하게 보일 수 있지만, 각 조각에 맞는 하나의 공간이 있습니다. 모든 조각이 장소에 맞게 놓이면 아름다운 이미지가 만들어질 것입니다! 과정을 즐겨보세요하고 집중력을 높이세요!",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "로직",
        "슬라이딩 퍼즐",
        "시간소비자"
      ]
    },
    "fr": {
      "title": "Le plus difficile des puzzles jamais créé",
      "description": "Un jeu de puzzle passionnant pour toute la famille ! ?\n\nJouez ensemble et entraînez votre cerveau tous les jours ! ? Profitez de puzzles captivants adaptés même aux jeunes joueurs. Avec des niveaux nouveaux ajoutés quotidiennement, il y a toujours un nouveau défi qui vous attend !\n\nAmusez-vous, améliorez vos compétences, et devenez un véritable maître du puzzle ! ?",
      "instructions": "Dans ce jeu, votre objectif est de former une image lumineuse en déplaçant des pièces sur le plateau. Déplacez simplement les pièces et posez-les à leur place correcte jusqu'à ce que l'image soit complète. Faites attention, car certaines pièces peuvent sembler similaires, mais il n'y a qu'un emplacement correct pour chaque pièce. Une fois toutes les pièces en place, vous verrez l'image belle se former ! Profitez du processus et affinez votre attention !",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "logique",
        "puzzle glissant",
        "tueur de temps"
      ]
    }
  }
};
